import { createContext, JSX, ReactNode, useEffect, useState } from "react";
import Roles from "../../user/roles";
import { ProjectRunConfigurationStatus } from "../enumerators";
import Project from "../project";
import AccuracyGapAnalysisService from "./AccuracyGapAnalysisService";
import { AccuracyGapAnalysisUiProps } from "./accuracyGapAnalysisUiProps";
import { AccuracyGapAnalysisConfiguration } from "./accuracyGapAnalysisConfiguration";

type AccuracyGapAnalysisInternalProps = {
  project: Project;
  projectRunConfigurationId: number;
  publishStatus: boolean;
  runConfigurationstatus: ProjectRunConfigurationStatus;
  userRoles: string[];
} & { children: ReactNode };

export const AccuracyGapAnalysisContext = createContext<AccuracyGapAnalysisUiProps>({ primaryConfiguration: null, supplementaryConfiguration: null });

export const AccuracyGapAnalysisContextProvider = (props: AccuracyGapAnalysisInternalProps): JSX.Element => {
  const [primaryConfiguration, setPrimaryConfiguration] = useState<AccuracyGapAnalysisConfiguration>();
  const [supplementaryConfiguration, setSupplementaryConfiguration] = useState<AccuracyGapAnalysisConfiguration>();

  useEffect(() => {
    const accuracyGapAnalysisService = new AccuracyGapAnalysisService();
    if (!props.project || !props.project.projectId || !props.projectRunConfigurationId || props.runConfigurationstatus != ProjectRunConfigurationStatus.Succeeded || !props.project.showAccuracyGapAnalysis
      || !(props.userRoles.includes(Roles.ACCURACY_LICENSE_TIER_1) || props.userRoles.includes(Roles.ACCURACY_LICENSE_TIER_2))) return;
    
    accuracyGapAnalysisService.getAccuracyGapAnalysisData(props.project.projectId, props.projectRunConfigurationId, props.publishStatus)
    .then((response) => {
      if ( !response ) return;
      setPrimaryConfiguration(response.primaryConfiguration);
      setSupplementaryConfiguration(response.supplementaryConfiguration);
    });
  }, [props.project, props.projectRunConfigurationId, props.publishStatus]);

  return (
    <AccuracyGapAnalysisContext.Provider
      value={{
        primaryConfiguration,
        supplementaryConfiguration,
      }}
    >
      {props.children}
    </AccuracyGapAnalysisContext.Provider>
  );
};
